import { render } from "./Statement_Transactions.vue?vue&type=template&id=45c98260"
import script from "./Statement_Transactions.vue?vue&type=script&lang=js"
export * from "./Statement_Transactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__